import React, { useState } from "react";

import { Switch, Tooltip } from "antd";
import { InfoCircleFilled } from "@ant-design/icons";

import { Facility } from "src/interface";
import { updateFacilityProfile } from "../../../api/facility";
import { logError } from "src/appV2/lib/analytics";
import {
  Container,
  EnableVariableChargeContainer,
  SectionTitle,
  Title,
  infoCircleStyle,
} from "./styles";
import { logEvent } from "@src/appV2/lib/analytics";
import { ADMIN_EVENTS } from "../../../constants/firebaseEvents";
import { useVariableChargeRevampFlag } from "../../../hooks/useVariableChargeRevampFlag";
import { showErrorToast } from "@src/appV2/lib/Notifications";

interface VariableChargeToggleProps {
  facility: Facility;
  adminProfile?: {
    email: string;
    userId?: string;
    roles?: string[];
  };
}

export function VariableChargeToggle({ facility, adminProfile }: VariableChargeToggleProps) {
  const [isLoading, setIsLoading] = useState(false);
  const [variableChargeEnabled, setVariableChargeEnabled] = useState(
    facility?.variableCharge?.enabled ?? false
  );

  const { isVariableChargeRevampEnabled } = useVariableChargeRevampFlag();

  const onFieldChange = async (value: boolean) => {
    setIsLoading(true);
    try {
      await updateFacilityProfile({
        facilityId: facility.userId,
        variableCharge: {
          enabled: value,
        },
        performedBy: adminProfile?.userId,
      });
      setVariableChargeEnabled(value);
      logEvent(ADMIN_EVENTS.VARIABLE_CHARGE_STATUS_UPDATED, {
        facilityId: facility.userId,
        facilityName: facility.name,
        updatedValue: String(value),
        performedBy: {
          userId: adminProfile?.userId,
          email: adminProfile?.email,
        },
      });
    } catch (error) {
      // FIXME: Automatically disabled during ESLint config update
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { message: errorMessage = "", stack = "" } = error as Error;
      logError("Error in VariableChargeToggle - onFieldChange", { error });
      showErrorToast("Error occurred while enabling the workplace to update shift rate.");
    } finally {
      setIsLoading(false);
    }
  };

  return isVariableChargeRevampEnabled ? (
    <Container>
      <SectionTitle>Variable Charge</SectionTitle>
      <div className="content">
        <EnableVariableChargeContainer>
          <Title>Allow workplace to update shift rate</Title>
          <Switch
            data-testid="variable-charge-status-toggle"
            checked={variableChargeEnabled ?? false}
            onChange={onFieldChange}
            loading={isLoading}
          />
          <Tooltip
            title={
              <div>
                Enabling this toggle allows workplace to update the shift rate by utilizing Variable
                Charge and Rate recommendation.
              </div>
            }
          >
            <InfoCircleFilled
              style={infoCircleStyle}
              data-testid="variable-charge-information-icon"
            />
          </Tooltip>
        </EnableVariableChargeContainer>
      </div>
    </Container>
  ) : null;
}
